module.exports = __webpack_public_path__ + "assets/images/shop10.35c67c70.png";